import type { SVGProps } from 'react';

export const Fashion = (props: SVGProps<any>) => (
  <svg height="32px" role="img" viewBox="0 0 32 32" width="32px" {...props}>
    <title>{'fashion'}</title>
    <g transform="scale(1,-1) translate(0 -512)">
      <path
        d="M502 45l-35 298c-3 25-26 46-51 46l-7 0c0-3 0-5 0-7 0-22-17-39-39-39-21 0-39 17-39 39 0 2 0 4 0 7l-150 0c0-3-1-5-1-7 0-22-17-39-38-39-22 0-39 17-39 39 0 2 0 4 0 7l-7 0c-25 0-48-21-51-46l-35-298c-3-25 15-45 40-45l412 0c25 0 43 20 40 45m-376 337c0 72 58 130 130 130 72 0 130-58 130-130 0-9-7-16-16-16-9 0-16 7-16 16 0 2 0 4 0 6 0 1 0 1 0 1-4 51-46 91-98 91-52 0-95-40-98-91 0 0 0 0 0-1 0-2 0-4 0-6 0-9-8-16-16-16-9 0-16 7-16 16"
        fill={props.fill}
      />
    </g>
  </svg>
);
